export const SAVE_NEXT_VIDEO_ID = 'SAVE_NEXT_VIDEO_ID';
export const SAVE_NEXT_AUDIO_ID = 'SAVE_NEXT_AUDIO_ID';
export const TOGGLE_NEXT_CALL_VIDEO = 'TOGGLE_NEXT_CALL_VIDEO';
export const TOGGLE_NEXT_CALL_AUDIO = 'TOGGLE_NEXT_CALL_AUDIO';
export const RESET_CALL_SETTINGS = 'RESET_CALL_SETTINGS';
export const TOGGLE_REMEMBER_SETTINGS = 'TOGGLE_REMEMBER_SETTINGS';
export const SET_NEXT_CALL_OUTPUT = 'SET_NEXT_CALL_OUTPUT';
export const PSTN_ID = 'PSTN';
export const AV_SETTINGS = 'AV_SETTINGS';
